export default class VindiPagamentosAdminConfig {
    constructor() {
        this.enableCancelRefundField = document.getElementById('vindi-pagamentos-enable_cancel_refund');
        this.conditionalFields = document.querySelectorAll('[data-condition="vindi-pagamentos-enable_cancel_refund"], .wc-settings-row-vindi-pagamentos-authorization-status');

        this.init();
    }

    init() {
        if (this.enableCancelRefundField) {
            this.enableCancelRefundField.addEventListener('change', () => this.toggleConditionalFields());
            this.toggleConditionalFields();
        }
        this.addAuthorizationButton();
        this.addTestConnectionButton();
        this.addTokenValidation();
    }

    addTokenValidation() {
        const form = document.getElementById('mainform');
        if (!form) {
            return;
        }

        form.addEventListener('submit', (e) => {
            const tokenField = document.getElementById('vindi-pagamentos-token');
            if (!tokenField) {
                return;
            }

            const trimmedValue = tokenField.value.trim();
            tokenField.value = trimmedValue;

            if (trimmedValue === '') {
                return;
            }

            if (trimmedValue.length !== 15) {
                alert('Token inválido. O token deve ter 15 caracteres.');
                tokenField.focus();
                e.preventDefault();
            }
        });
    }

    toggleConditionalFields() {
        this.conditionalFields.forEach(field => {
            const row = field.closest('tr');
            if (row) {
                row.style.display = this.enableCancelRefundField.checked ? '' : 'none';
            } else {
                field.style.display = this.enableCancelRefundField.checked ? 'block' : 'none';
            }
        });
    }

    addAuthorizationButton() {
        const authorizationField = document.getElementById('vindi-pagamentos-authorization-code');
        if (!authorizationField) {
            return;
        }

        if (authorizationField.nextElementSibling?.classList.contains('authorize-button')) {
            return;
        }

        const button = document.createElement('button');
        button.textContent = 'Autorizar';
        button.className = 'components-button authorize-button is-secondary';
        button.style.margin = '0 10px';
        button.style.height = '30px';
        button.type = 'button';
        button.title = 'Preencha a Consumer Key e Consumer Secret para habilitar a autorização';
        button.disabled = true;

        const consumerKey = document.getElementById('vindi-pagamentos-consumer_key');
        const consumerSecret = document.getElementById('vindi-pagamentos-consumer_secret');

        if (!consumerKey || !consumerSecret) {
            return;
        }

        const validateFields = () => {
            const isValid = consumerKey.value.trim() !== '' && consumerSecret.value.trim() !== '';
            button.disabled = !isValid;
            button.title = isValid ? 'Clique para autorizar' : 'Preencha a Consumer Key e Consumer Secret para habilitar a autorização';
        };

        consumerKey.addEventListener('input', validateFields);
        consumerSecret.addEventListener('input', validateFields);
        validateFields();

        button.addEventListener('click', () => {
            this.manageAuthorization();
        });

        authorizationField.insertAdjacentElement('afterend', button);
    }

    /**
     * Manages the authorization process by submitting the form data via a POST request.
     * If the request is successful, it redirects the user to the Yapay authentication page.
     * If the request fails, it displays an error message.
     *
     * @function
     * @name manageAuthorization
     */
    manageAuthorization() {
        const formData = new FormData(document.querySelector('form'));
        formData.append('save', '1');
        fetch(window.location.href, {
            method: 'POST',
            body: formData,
        }).then(response => {
            if (response.ok) {
                window.onbeforeunload = null;
                
                const consumerKeyField = document.getElementById('vindi-pagamentos-consumer_key');
                const environmentField = document.getElementById('vindi-pagamentos-environment');
                
                if (!consumerKeyField) {
                    return;
                }
                
                const consumerKey = consumerKeyField.value;
                const environment = environmentField ? environmentField.value : vindiPagamentosConfig.environment;
                
                const authorizationUrl = environment === 'sandbox'
                    ? vindiPagamentosConfig.sandboxAuthorizationUrl
                    : vindiPagamentosConfig.authorizationUrl;
                    
                window.location.href = `${authorizationUrl}?consumer_key=${consumerKey}`;
            }
        })
    }

    addTestConnectionButton() {
        const authorizationField = document.getElementById('vindi-pagamentos-authorization-code');
        if (!authorizationField) {
            return;
        }

        const existingButton = authorizationField.parentElement.querySelector('.test-connection-button');
        if (existingButton) {
            return;
        }

        const button = document.createElement('button');
        button.textContent = 'Testar Conexão';
        button.className = 'components-button test-connection-button is-secondary';
        button.style.margin = '0 10px';
        button.style.height = '30px';
        button.type = 'button';

        button.addEventListener('click', () => this.testConnection());

        const authorizeButton = authorizationField.parentElement.querySelector('.authorize-button');
        if (authorizeButton) {
            authorizeButton.insertAdjacentElement('afterend', button);
        } else {
            authorizationField.insertAdjacentElement('afterend', button);
        }
    }

    async testConnection() {
        const button = document.querySelector('.test-connection-button');
        const consumerKeyField = document.getElementById('vindi-pagamentos-consumer_key');
        const consumerSecretField = document.getElementById('vindi-pagamentos-consumer_secret');
        const authorizationField = document.getElementById('vindi-pagamentos-authorization-code');
        const environmentField = document.getElementById('vindi-pagamentos-environment');

        if (!consumerKeyField || !consumerSecretField || !authorizationField) {
            alert('Campos necessários não encontrados.');
            return;
        }

        const consumerKey = consumerKeyField.value;
        const consumerSecret = consumerSecretField.value;
        const authorizationCode = authorizationField.value;
        const environment = environmentField ? environmentField.value : vindiPagamentosConfig.environment;
        const statusElement = document.querySelector('.wc-settings-row-vindi-pagamentos-authorization-status td');

        if (!consumerKey || !consumerSecret) {
            alert('Por favor, preencha Consumer Key e Consumer Secret.');
            return;
        }

        if (!authorizationCode || authorizationCode.includes('*')) {
            alert('Por favor, preencha o Código de Autorização.');
            return;
        }

        button.disabled = true;
        button.textContent = 'Testando...';

        try {
            const formData = new FormData();
            formData.append('action', 'vindi_test_connection');
            formData.append('nonce', vindiPagamentosConfig.testConnectionNonce);
            formData.append('consumer_key', consumerKey);
            formData.append('consumer_secret', consumerSecret);
            formData.append('authorization_code', authorizationCode);
            formData.append('environment', environment);

            const response = await fetch(ajaxurl, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (result.success) {
                alert(result.data.message);
                if (statusElement) {
                    statusElement.innerHTML = '<span style="color:green">Autorizado</span>';
                }
            } else {
                alert(result.data.message);
                if (statusElement) {
                    statusElement.innerHTML = '<span style="color:red">Falha na integração</span>';
                }
            }
        } catch (error) {
            alert('Erro ao testar conexão: ' + error.message);
        } finally {
            button.disabled = false;
            button.textContent = 'Testar Conexão';
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new VindiPagamentosAdminConfig();
});
